module.exports = __webpack_public_path__ + "media/images/athletes/2914-3c1b1ff41baa5c5c73500c015e9017af.png";